import React, { useMemo } from 'react';

import { Heading, Text, VStack } from '@rtkwlf/fenrir-react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useScannerDetails } from '@apis/rendall/queries/use-scanner-details/use-scanner-details';

import {
  scannerDetailSelect,
  type ScanExclusionType,
} from '../../../../../../../../hooks/use-enhanced-scanner-details/use-enhanced-scanner-details';

import type { AddIpRangeForm } from './components/add-ip-range-form/add-ip-range-form';
import { ScanExclusionTable } from './components/scan-exclusion-table/scan-exclusion-table';

export const ScanExclusionReadOnly: React.FC = () => {
  const formMethods = useForm<AddIpRangeForm>();

  const { t } = useTranslation('telemetryScannerConfig');

  const { scannerId = '' } = useParams();
  const { data: scannerDetails, isSuccess } = useScannerDetails(scannerId, {
    select: scannerDetailSelect,
  });

  const tableData: ScanExclusionType[] = useMemo(() => {
    if (isSuccess) {
      const scanExclusionDenyList: Array<ScanExclusionType> =
        scannerDetails?.denyList?.map((denyList) => ({
          ipRange: denyList,
          ports: '',
        })) || [];

      return [...scannerDetails.portBlockRules, ...scanExclusionDenyList];
    }

    return [];
  }, [isSuccess, scannerDetails]);

  return (
    <VStack width="full">
      <Heading level="4" paddingY="xsmall">
        {t('scanExclusion.addScanExclusion')}
      </Heading>
      <Text styledAs="body2">
        {t('scanExclusion.addScanExclusionDescriptionLine1')}
      </Text>
      <Text styledAs="body2" marginBottom="medium">
        {t('scanExclusion.addScanExclusionDescriptionLine2')}
      </Text>
      <Text styledAs="body2">{t('scanExclusion.bulkUploadDescription')}</Text>
      <Heading level="4" paddingY="xsmall">
        {t('scanExclusion.scanExclusionList')}
      </Heading>
      <FormProvider {...formMethods}>
        <ScanExclusionTable tableData={tableData} />
      </FormProvider>
    </VStack>
  );
};
